import { Link, useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-styled-flexboxgrid';

import { Avatar } from '../Global/Atomics/Avatar';
import Box from '../Global/Atomics/Box';
import { Container } from '../Global/Atomics/Container';
import CustomIcon from '../Global/Icons/CustomIcon';

import Theme from '../../styles/Theme/Theme';
import { useAuthContext } from '../../contexts/AuthContext';

type TProps = {
    bg?: keyof typeof Theme.color;
    children?: React.ReactNode;
}

export const Header = ({ bg, children }: TProps) => {
    const navigate = useNavigate();
    const { user } = useAuthContext();

    return (
        <Box bg={bg ? bg : 'white'}>
            <Container as="header" mt="lg" mb="md">
                <Row between="xs" middle="xs">
                    <Col> <Link to="/home" aria-label='Nova Logo'><CustomIcon icon="NovaLogo_2" width={92} height={40} /></Link></Col>
                    <Col style={{ zIndex: 100 }}>
                        <Avatar border="none" type="button" position="relative" bg="black-1" size={40} onClick={() => navigate('/profile')}>
                            <Box as="span" typography='ui-xl-medium' color="white">
                                {user?.name?.split(" ")[0]?.charAt(0)?.toUpperCase()}{user?.name.split(" ").pop().charAt(0)?.toUpperCase()}
                            </Box>
                        </Avatar>
                    </Col>
                </Row>
            </Container>
            {children ? children : null}
        </Box>
    );
};
